/**
 * Created by neo on 10.01.2026
 */
import { makeAutoObservable } from 'mobx';

export type PointsLimitStatus = {
  remainingDaily?: number;
  remainingTotal?: number;
  effectiveLimit?: number;
  dailyLimit?: number;
  totalLimit?: number;
  readonly hasAnyLimit: boolean;
  readonly isLimitReached: boolean;
  readonly collectedToday: number;
  readonly progressPercent: number;
};

export function createPointsLimitStatus(json?: Partial<PointsLimitStatus>): PointsLimitStatus {
  return makeAutoObservable({
    remainingDaily: json?.remainingDaily,
    remainingTotal: json?.remainingTotal,
    effectiveLimit: json?.effectiveLimit,
    dailyLimit: json?.dailyLimit,
    totalLimit: json?.totalLimit,

    get hasAnyLimit(): boolean {
      return !!this.dailyLimit;
    },

    get isLimitReached(): boolean {
      return this.hasAnyLimit ? (this.remainingDaily ?? 0) <= 0 : false;
    },

    get collectedToday(): number {
      if (!this.dailyLimit) return 0;
      return this.dailyLimit - (this.remainingDaily ?? 0);
    },

    get progressPercent(): number {
      if (!this.dailyLimit) return 0;
      return Math.min(100, (this.collectedToday / this.dailyLimit) * 100);
    },
  });
}
